import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { AjoutePromotion, AffichePromotion, AffichePromotionSpecial, AffichePromotionRestaurant } from '../../Api/RestaurantApi/PromotionApi';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { BASE_URL } from '../../Utils/base_url';
import { blockInvalidChar } from "../../components/blockInvalidChar";
import { PhotoProvider, PhotoView } from 'react-photo-view';

// Visualiser
import Pagination from '@material-ui/lab/Pagination';
import Slider from "react-slick";
import Image6 from "../../Image/une (1).png";
import Image7 from "../../Image/une (2).jpg";
import Image10 from "../../Image/une (5).png";
import Image11 from "../../Image/une (6).jpg";
import Chef from "../../Image/chef.png";
import EntrerIcon from "../../Image/entrer.png";
import PlatIcon from "../../Image/plats.png";
import DessertIcon from "../../Image/desserts.png";
import BoissonIcon from "../../Image/boisson.png";
import Money from "../../Image/money.png";
import Plus from "../../Image/plus.png";
import Menus from "../../Image/menus.png";
import Avatar1 from "../../Image/avatar1.png";
import Avatar2 from "../../Image/Avatar2.png";



import './css/promotionResto.css';

const Promotion = () => {
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [selected, setSelected] = useState(0);
  const [libelleSpecial, setLibelleSpecial] = useState('');
  const [errorLibelle, setErrorLibelle] = useState('');
  const [prixSpecial, setPrixSpecial] = useState('');
  const [errorPrix, setErrorPrix] = useState('');
  const [statusContenuMenu, setStatusContenuMenu] = useState(true);
  const [errorContenuMenu, setErrorContenuMenu] = useState('');
  const [platMenu, setPlatMenu] = useState('');
  const [statuReservant, setStatuReservant] = useState(false);
  const [statusIntroduire, setStatusIntroduire] = useState(false);
  const [errorIntroduire, setErrorIntroduire] = useState('');
  const [introduire, setIntroduire] = useState('');

  const [statusEntrer, setStatusEntrer] = useState(false);
  const [errorEntrer, setErrorEntrer] = useState('');
  const [statusPlat, setStatusPlat] = useState(false);
  const [errorPlat, setErrorPlat] = useState('');
  const [statusDessert, setStatusDessert] = useState(false);
  const [errorDessert, setErrorDessert] = useState('');
  const [statusAutre, setStatusAutre] = useState(false);
  const [errorAutre, setErrorAutre] = useState('');


  const [entrer, setEntrer] = useState('');

  const [dataEntrer, setDataEntrer] = useState([]);
  const [plat, setPlat] = useState('');
  const [dataPlat, setDataPlat] = useState([]);
  const [dessert, setDessert] = useState('');
  const [dataDessert, setDataDessert] = useState([]);
  const [nomAutre, setNomAutre] = useState('');
  const [autre, setAutre] = useState('');
  const [dataAutre, setDataAutre] = useState([]);


  const [promo, setPromo] = useState([
    {
      id: 1,
      status: false,
      name: "Promotion de -50%",
      libelle: "Promotion : -50 % sur la carte !",
      horsBoisson: false,
      toutCommande: false
    },
    {
      id: 2,
      status: false,
      name: "Promotion de -40%",
      libelle: "Promotion : -40% sur la carte !",
      horsBoisson: false,
      toutCommande: false
    },
    {
      id: 3,
      status: false,
      name: "Promotion de -30%",
      libelle: "Promotion : -30 % sur la carte !",
      horsBoisson: false,
      toutCommande: false
    },
    {
      id: 4,
      status: false,
      name: "Promotion de -20%",
      libelle: "Promotion : -20 % sur la carte !",
      horsBoisson: false,
      toutCommande: false
    },
    {
      id: 5,
      status: false,
      name: "Promotion de -10%",
      libelle: "Promotion : -10 % sur la carte !",
      horsBoisson: false,
      toutCommande: false
    },
    {
      id: 6,
      status: false,
      name: "Promotion : Menu spécial",
      libelle: "Promotion : Menu spécial",
    }
  ]);



  const [autrePlatMenu, setAutrePlatMenu] = useState({
    check: false,
    name: ""
  })
  const [avecContenu, setAvecContenu] = useState([{
    id: 1,
    check: false,
    name: "Boisson",
  },
  {
    id: 2,
    check: false,
    name: "Café",
  },
  ]);

  const avecContenuTrue = avecContenu.filter((el) => el.check === true);





  // Visualiser

  const [show, setShow] = useState(false);
  const [showSpecial, setShowSpecial] = useState(false);


  const [prixMoyenne, setPrixMoyenne] = useState([]);
  const [entrerResto, setEntrerResto] = useState([]);
  const [platResto, setPlatResto] = useState([]);
  const [dessertResto, setDessertResto] = useState([]);
  const [menuResto, setMenuResto] = useState([]);
  const [elementMenu, setElementMenu] = useState([]);
  const [description, setDescription] = useState("");
  const [planUrl, setPlanUrl] = useState("");
  const [precision, setPrecision] = useState("");
  const [selectImage, setSelectImage] = useState([]);
  const [cuisine, setCuisine] = useState([]);
  const [boisson, setBoisson] = useState([]);


  const [service, setService] = useState([]);
  const [regime, setRegime] = useState([]);
  const [payement, setPayement] = useState([]);




  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    speed: 2000,
    autoplaySpeed: 8000,
    swipeToSlide: true,
    slidesToShow: selectImage.length < 4 ? selectImage.length : 4,
    slidesToScroll: selectImage.length < 4 ? selectImage.length : 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: selectImage.length < 3 ? selectImage.length : 3,
          slidesToScroll: selectImage.length < 3 ? selectImage.length : 3,
          initialSlide: selectImage.length < 3 ? selectImage.length : 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: selectImage.length < 2 ? selectImage.length : 2,
          slidesToScroll: selectImage.length < 2 ? selectImage.length : 2,
          initialSlide: selectImage.length < 2 ? selectImage.length : 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
          slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: selectImage.length < 1 ? selectImage.length : 1,
          slidesToScroll: selectImage.length < 1 ? selectImage.length : 1
        }
      }
    ]
  };



  const handleCloseDetailMenu = () => setShow(false);
  const handleShowDetailMenu = (el) => {
    setElementMenu(el);
    setShow(true);

  };

  const handleCloseDetailSpecial = () => setShowSpecial(false);
  const handleShowDetailSPecial = () => {
    setShowSpecial(true);

  };


  const viewPromotion = () => {
    const existePromo50 = promo.find((el) => el.name === "Promotion de -50%" && el.status === true);
    const existePromo40 = promo.find((el) => el.name === "Promotion de -40%" && el.status === true);
    const existePromo30 = promo.find((el) => el.name === "Promotion de -30%" && el.status === true);
    const existePromo20 = promo.find((el) => el.name === "Promotion de -20%" && el.status === true);
    const existePromo10 = promo.find((el) => el.name === "Promotion de -10%" && el.status === true);
    const existePromoSpecial = promo.find((el) => el.name === "Promotion : Menu spécial" && el.status === true);

    if (existePromo50) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -50%</span>);
    } else if (existePromo40) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -40%</span>);
    } else if (existePromo30) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -30%</span>);
    } else if (existePromo20) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -20%</span>);
    } else if (existePromo10) {
      return (<span><i className='fa fa-bullhorn'></i>Promotion -10%</span>);
    } else if (existePromoSpecial) {
      return (<span><i className='fa fa-bullhorn'></i>Menu spécial</span>);

    } else {
      return (<span><i className='fa fa-bullhorn'></i>Pas de promotion ...</span>);
    }


  }



  const viewCreneau = (creneau) => {
    var opt_month = { month: 'long' };
    function toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    }
    var MonthDu = toTitleCase(new Date(creneau.du).toLocaleDateString("fr-FR", opt_month));
    var MonthAu = toTitleCase(new Date(creneau.au).toLocaleDateString("fr-FR", opt_month));
    const du = new Date(creneau.du);
    const au = new Date(creneau.au);
    const fin = new Date(creneau?.au).getTime();
    const date = new Date();
    if (fin >= date.getTime()) {
      return (<p>{du.getDate() + " " + MonthDu + " " + du.getFullYear()} au {au.getDate() + " " + MonthAu + " " + au.getFullYear()}</p>);
    } else {
      return (<p>Promotion Expirée !</p>)
    }
  }




  // Fin visualiser





  const restaurant = useSelector((state) => state.restaurant);
  const exitePromo = promo.filter((el) => el.status === true);




  useEffect(() => {
    promotion();
    promotionSpecial();
    promotionRestaurant();
  }, []);


  const promotion = () => {
    setLoadData(true);
    AffichePromotion(restaurant.id).then(function (response) {
      console.log('aaffiche value =>', response.data.donner);
      response.data.donner.forEach((el) => {
        setPromo((prev) => {
          return prev.map((item) => {
            if (item.name === el.libelle) {
              if (item.name !== 'Promotion : Menu spécial') {
                return { ...item, status: true, horsBoisson: el.horsBoisson, toutCommande: el.pourTout };
              } else {
                return { ...item, status: true };
              }
            } else {
              return { ...item };
            }
          });
        });
      });


    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }


  const promotionRestaurant = () => {
    setLoadData(true);
    AffichePromotionRestaurant(restaurant.id).then(function (response) {
      console.log('Restaurant promotion =>', response.data.donner);
      setDescription(response.data.donner.description);
      setPlanUrl(response.data.donner.urlPlan);
      setPrecision(response.data.donner.precision);
      setPrixMoyenne(response.data.donner.prixMoyenne);
      setEntrerResto(response.data.donner.entrers);
      setPlatResto(response.data.donner.plats);
      setDessertResto(response.data.donner.desserts);
      setMenuResto(response.data.donner.menus);
      setCuisine(response.data.donner.typeCuisines);
      setSelectImage(response.data.donner.photos);
      setBoisson(response.data.donner.boissons);
      setService(response.data.donner.serviceRestaurant);
      setPayement(response.data.donner.payements);
      setRegime(response.data.donner.regimeAlimentaires);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }


  const promotionSpecial = () => {
    AffichePromotionSpecial(restaurant.id).then(function (response) {
      console.log('affiche value Special=>', response.data.donner);
      response.data.donner.forEach((el) => {
        el.avecContenuSpecials.map((data) =>
          setAvecContenu((prev) => {
            return prev.map((item) => {
              if (item.name === data.libelle) {
                return { ...item, check: true };
              } else {
                return { ...item };
              }
            });
          })
        );
        setAutrePlatMenu({
          check: el.autrePlatMenu === "" ? false : true,
          name: el.autrePlatMenu
        });

        el.autreSpecials.map((data) => setDataAutre((prev) => [...prev, { name: data.libelle }]));

        setPlatMenu(el.contenuMenu);
        el.dessertSpecials.map((data) => setDataDessert((prev) => [...prev, { name: data.libelle }]));
        el.entrerSpecials.map((data) => setDataEntrer((prev) => [...prev, { name: data.libelle }]));
        setIntroduire(el.introduire);
        setLibelleSpecial(el.libelle);
        setNomAutre(el.nomAutre);
        el.platSpecials.map((data) => setDataPlat((prev) => [...prev, { name: data.libelle }]));
        setPrixSpecial(el.prix);
        setStatusAutre(el.statusAutre === "1" ? true : false);
        setStatusDessert(el.statusDessert === "1" ? true : false);
        setStatusEntrer(el.statusEntrer === "1" ? true : false);
        setStatusPlat(el.statusPlat === "1" ? true : false);
        setStatuReservant(el.statusReservant === "1" ? true : false);
        setStatusIntroduire(el.statusIntroduire === "1" ? true : false);
      });


    }).catch(function (error) {
      console.log(error);
    });
  }

  const toogle = (i) => {
    if (selected === i) {
      setSelected(null);
    }
    setSelected(i);
  }

  const [showModal, setShowModal] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);

  const handleStatus = (id) => {
    setPromo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, status: !item.status };
        } else {
          return { ...item };
        }
      });
    });
  }
  const handlehorsBoisson = (id) => {
    setPromo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          if (item.status === false) {
            if (item.horsBoisson === false) {
              return { ...item, horsBoisson: !item.horsBoisson, status: true };
            } else {
              return { ...item, horsBoisson: !item.horsBoisson };
            }
          } else {
            return { ...item, horsBoisson: !item.horsBoisson, status: true };
          }
        } else {
          return { ...item };
        }
      });
    });
  }

  const handleToutCommande = (id) => {
    setPromo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          if (item.status === false) {
            if (item.toutCommande === false) {
              return { ...item, toutCommande: !item.toutCommande, status: true };
            } else {
              return { ...item, toutCommande: !item.toutCommande };
            }

          } else {
            return { ...item, toutCommande: !item.toutCommande, status: true };
          }

        } else {
          return { ...item };
        }
      });
    });
  }





  const handleSpecialLibelle = (value, id, i) => {
    setPromo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          if (item.status === false) {
            return { ...item, status: true };
          } else {
            return { ...item };
          }
        } else {
          return { ...item };
        }
      });
    });

    setLibelleSpecial(value);

    if (selected === i) {
      setSelected(null);
    }
    setSelected(i);
  }


  const handleSpecialPrix = (value, id, i) => {
    setPromo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          if (item.status === false) {
            return { ...item, status: true };
          } else {
            return { ...item };
          }
        } else {
          return { ...item };
        }
      });
    });

    setPrixSpecial(value);

    if (selected === i) {
      setSelected(null);
    }
    setSelected(i);
  }


  const handleChangeStatusContenu = () => {
    setStatusContenuMenu(!statusContenuMenu);
    setErrorContenuMenu('');
  }




  const handlePlatMenu = (platMenu) => {
    setAutrePlatMenu({
      check: false,
      name: ''
    });
    if (statusContenuMenu === false) {
      setErrorContenuMenu('Active cette bloc menu pour ajouter son contenue !');
      setPlatMenu(platMenu);
      const timer = setTimeout(() => setErrorContenuMenu(''), 3000);
      return () => clearTimeout(timer);
    } else {
      setPlatMenu(platMenu);
      setErrorContenuMenu('');
    }
  }

  const handleAutrePlatMenu = (e) => {
    if (e.target.name === "check") {
      setPlatMenu("");
      setAutrePlatMenu({
        ...autrePlatMenu,
        [e.target.name]: !autrePlatMenu.check
      })
    } else {
      setPlatMenu("");
      setAutrePlatMenu({
        ...autrePlatMenu,
        name: e.target.value,
        check: true
      });
    }

  }
  const handleCheckAvecContenu = (id) => {
    setStatusContenuMenu(true);
    setAvecContenu((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, check: !item.check };
        } else {
          return { ...item };
        }
      });
    });
  }


  const handleStatusIntroduire = (e) => {
    if (statusIntroduire === false) {
      setStatusIntroduire(true);
      setIntroduire(e.target.value);
    } else {
      setIntroduire(e.target.value);
      setErrorIntroduire("");
    }

  }





  const handleAddEntrer = () => {
    setStatusEntrer(true);
    const existeEntrer = dataEntrer.find((el) => el.name === entrer);
    if (existeEntrer) {
      setErrorEntrer('Données existe déjas !');
      const timer = setTimeout(() => setErrorEntrer(''), 3000);
      return () => clearTimeout(timer);
    } else {
      if (entrer === "") {
        setErrorEntrer('Données obligatoire !');
        if (dataEntrer.length === 0) {
          setStatusEntrer(false);
        }
        const timer = setTimeout(() => setErrorEntrer(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (dataEntrer.length < 3) {
          setDataEntrer([...dataEntrer, { name: entrer }]);
          setErrorEntrer('');
          setEntrer('');
          setStatusEntrer(true);
        } else {
          setErrorEntrer('Données max 3 !');
          const timer = setTimeout(() => setErrorEntrer(''), 3000);
          return () => clearTimeout(timer);
        }
      }
    }

  }
  const handleDeleteEntrer = (name) => {
    if (dataEntrer.length === 1) {
      setStatusEntrer(false);
      setDataEntrer(dataEntrer.filter((el) => el.name !== name));
    } else {
      setDataEntrer(dataEntrer.filter((el) => el.name !== name));
    }
  }


  const handleAddPlat = () => {
    setStatusPlat(true);
    const existePlat = dataPlat.find((el) => el.name === plat);
    if (existePlat) {
      setErrorPlat('Données existe déjas !');
      const timer = setTimeout(() => setErrorPlat(''), 3000);
      return () => clearTimeout(timer);
    } else {
      if (plat === "") {
        setErrorPlat('Données obligatoire !');
        if (dataPlat.length === 0) {
          setStatusPlat(false);
        }
        const timer = setTimeout(() => setErrorPlat(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (dataPlat.length < 3) {
          setDataPlat([...dataPlat, { name: plat }]);
          setErrorPlat('');
          setPlat('');
          setStatusPlat(true);
        } else {
          setErrorPlat('Données max 3 !');
          const timer = setTimeout(() => setErrorPlat(''), 3000);
          return () => clearTimeout(timer);
        }
      }
    }

  }
  const handleDeletePlat = (name) => {
    if (dataPlat.length === 1) {
      setStatusPlat(false);
      setDataPlat(dataPlat.filter((el) => el.name !== name));
    } else {
      setDataPlat(dataPlat.filter((el) => el.name !== name));
    }
  }


  const handleAddDessert = () => {
    setStatusDessert(true);
    const existeDessert = dataDessert.find((el) => el.name === dessert);
    if (existeDessert) {
      setErrorDessert('Données existe déjas !');
      const timer = setTimeout(() => setErrorDessert(''), 3000);
      return () => clearTimeout(timer);
    } else {
      if (dessert === "") {
        setErrorDessert('Données obligatoire !');
        if (dataDessert.length === 0) {
          setStatusDessert(false);
        }
        const timer = setTimeout(() => setErrorDessert(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (dataDessert.length < 3) {
          setDataDessert([...dataDessert, { name: dessert }]);
          setDessert('');
          setStatusDessert(true);
          setErrorDessert('');
        } else {
          setErrorDessert('Données max 3 !');
          const timer = setTimeout(() => setErrorDessert(''), 3000);
          return () => clearTimeout(timer);
        }
      }
    }

  }
  const handleDeleteDessert = (name) => {
    if (dataDessert.length === 1) {
      setStatusDessert(false);
      setDataDessert(dataDessert.filter((el) => el.name !== name));
    } else {
      setDataDessert(dataDessert.filter((el) => el.name !== name));
    }
  }




  const handleAddAutre = () => {
    setStatusAutre(true);
    const existeAutre = dataAutre.find((el) => el.name === autre);
    if (nomAutre === "") {
      setErrorAutre("Veuillez remplir le nom");
      const timer = setTimeout(() => setErrorAutre(''), 3000);
      return () => clearTimeout(timer);
    } else {
      if (existeAutre) {
        setErrorAutre(`${nomAutre} existe déjas !`);
        const timer = setTimeout(() => setErrorAutre(''), 3000);
        return () => clearTimeout(timer);
      } else {
        if (autre === "") {
          setErrorAutre(`Veuillez remplir le champ ${nomAutre} !`);
          if (dataAutre.length === 0) {
            setStatusAutre(false);
          }
          const timer = setTimeout(() => setErrorAutre(''), 3000);
          return () => clearTimeout(timer);
        } else {
          if (dataAutre.length < 3) {
            setDataAutre([...dataAutre, { name: autre }]);
            setErrorAutre('');
            setStatusAutre(true);
            setAutre('');
          } else {
            setErrorAutre(`Données max 3 !`);
            const timer = setTimeout(() => setErrorAutre(''), 3000);
            return () => clearTimeout(timer);
          }
        }
      }
    }
  }
  const handleDeleteAutre = (name) => {
    if (dataAutre.length === 1) {
      setStatusAutre(false);
      setDataAutre(dataAutre.filter((el) => el.name !== name));
    } else {
      setDataAutre(dataAutre.filter((el) => el.name !== name));
    }
  }





  let location = useLocation();

  const handleClose = () => setShowModal(false);
  const handleShow = (breakpoint) => {
    setFullscreen(breakpoint);
    setShowModal(true);
  };


  const dataPromo = promo.filter((el) => el.status === true);
  const dataAvecContenu = avecContenu.filter((el) => el.check === true);






  const handlePubier = () => {
    if (promo[5].status === true) {
      if (prixSpecial === "" && libelleSpecial === "") {
        setErrorLibelle('Libelle obligatoire');
        setErrorPrix('Prix Obligatoire');
        const timer = setTimeout(() => {
          setErrorLibelle('');
          setErrorPrix('');
        }, 3000);
        return () => clearTimeout(timer);
      } else if (prixSpecial !== "" && libelleSpecial === "") {
        setErrorLibelle('Libelle obligatoire');
        const timer = setTimeout(() => {
          setErrorLibelle('');
        }, 3000);
        return () => clearTimeout(timer);
      } else if (prixSpecial === "" && libelleSpecial !== "") {
        setErrorPrix('Prix Obligatoire');
        const timer = setTimeout(() => {
          setErrorPrix('');
        }, 3000);
        return () => clearTimeout(timer);
      } else {
        if (platMenu === "" && autrePlatMenu.name === "") {
          setErrorContenuMenu('Donner obligatoire');
          const timer = setTimeout(() => {
            setErrorContenuMenu('');
          }, 3000);
          return () => clearTimeout(timer);
        } else {
          if (!localStorage.getItem('tokenSociete')) {
            setLoading(true);
            const data = {
              idRestaurant: restaurant.id, promotion: dataPromo, promoSpecialPrix: prixSpecial,
              promoSpecialLibelle: libelleSpecial, promoSpecialContenuMenu: platMenu,
              promoSpecialAutrePlatMenu: autrePlatMenu.name, promoSpecialStatusReservant: statuReservant,
              promoSpecialStatusIntroduire: statusIntroduire, promoSpecialIntroduire: introduire, promoSpecialStatusEntrer: statusEntrer,
              promoSpecialStatusPlat: statusPlat, promoSpecialStatusDessert: statusDessert, promoSpecialStatusAutre: statusAutre,
              promoSpecialNomAutre: nomAutre, promoSpecialAvecContenu: dataAvecContenu,
              promoSpecialEntrer: dataEntrer, promoSpecialPlat: dataPlat, promoSpecialDessert: dataDessert, promoSpecialAutre: dataAutre
            };
            AjoutePromotion(data).then(function (response) {
              if (response.data.title === "success") {
                toast.success(response.data.message);
                promotion();
                promotionSpecial();
              }
            }).catch(function (error) {
              console.log(error.response);
              toast.warning(error.response.data.message);
            }).finally(function () {
              setStatusAutre(false);
              setStatusDessert(false);
              setStatusEntrer(false);
              setStatusPlat(false);
              setDataAutre([]);
              setDataEntrer([]);
              setDataDessert([]);
              setDataPlat([]);
              setLoading(false);
            });

          } else {
            toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
          }



        }
      }
    } else {
      if (!localStorage.getItem('tokenSociete')) {
        setLoading(true);
        const data = {
          idRestaurant: restaurant.id, promotion: dataPromo, promoSpecialPrix: prixSpecial,
          promoSpecialLibelle: libelleSpecial, promoSpecialContenuMenu: platMenu,
          promoSpecialAutrePlatMenu: autrePlatMenu.name, promoSpecialStatusReservant: statuReservant,
          promoSpecialStatusIntroduire: statusIntroduire, promoSpecialIntroduire: introduire, promoSpecialStatusEntrer: statusEntrer,
          promoSpecialStatusPlat: statusPlat, promoSpecialStatusDessert: statusDessert, promoSpecialStatusAutre: statusAutre,
          promoSpecialNomAutre: nomAutre, promoSpecialAvecContenu: dataAvecContenu,
          promoSpecialEntrer: dataEntrer, promoSpecialPlat: dataPlat, promoSpecialDessert: dataDessert, promoSpecialAutre: dataAutre
        };
        AjoutePromotion(data).then(function (response) {
          if (response.data.title === "success") {
            toast.success(response.data.message);
            promotion();
            promotionSpecial();
          }
        }).catch(function (error) {
          console.log(error.response);
          toast.warning(error.response.data.message);
        }).finally(function () {
          setStatusAutre(false);
          setStatusDessert(false);
          setStatusEntrer(false);
          setStatusPlat(false);
          setDataAutre([]);
          setDataEntrer([]);
          setDataDessert([]);
          setDataPlat([]);
          setLoading(false);
        });
      } else {
        toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
      }
    }
  }

  const handleCancel = () => {
    setStatusAutre(false);
    setStatusDessert(false);
    setStatusEntrer(false);
    setStatusPlat(false);
    setDataAutre([]);
    setDataEntrer([]);
    setDataDessert([]);
    setDataPlat([]);
    promotion();
    promotionSpecial();
  }






  const plural = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  const viewDate = (value) => {
    const date = new Date(value);
    return plural(date.getDate()) + "/" + plural(parseInt(date.getUTCMonth() + 1)) + "/" + date.getFullYear();
  }



  const viewAvisListe = (item, index) => {
    const nom = item.client.nom.charAt(0).toUpperCase();
    const prenom = item.client.prenom.charAt(0).toUpperCase();
    const clientAvis = restaurant.avis.filter((el) => el.client.id === item.client.id);
    return (
      <div className='resto_avis_liste' key={index}>
        <div className='row'>
          <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
            <div className='resto_avis_profile'>
              <div className='resto_avatar_client'>
                {
                  item.client.sexe === "Homme" ? <img src={Avatar2} alt="avatar client" /> : <img src={Avatar1} alt="avatar client" />
                }
              </div>
              {item.client.affichagePseudo === "1" ?
                <div className='pseudoClient d-flex flex-column'>
                  <span>{item.client.nom}</span>
                  <span className='text-center'>{item.client.prenom}</span>
                </div>
                : item.client.affichagePseudo === "2" ?
                  <span>{item.client.prenom} {nom}</span>
                  : item.client.affichagePseudo === "3" ?
                    <span>{prenom} {item.client.prenom}</span>
                    : <span>{nom} {prenom}</span>}
            </div>
          </div>
          <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
            <div className='resto_note_avis'>
              <div className='d-flex justify-content-center'>
                <div className='note_avis_content'>
                  <div>
                    <div className='resto_note_value'>Note/<span>{item.notes[0]?.note}</span></div>
                    <div className='resto_avis_value'>Avis/<span>{clientAvis.length}</span></div>
                  </div>
                </div>
              </div>
              <div className='resto_avis_date'>
                <span>{viewDate(item.createdAt)}</span>
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
            <div className='resto_content_avis'>
              <p>{item.avis}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }




  return (
    <div>
      <Helmet>
        <title>Promotions</title>
        <meta name='description' content='Restaurant promotions .' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='promotion'>
        <div className="container">
          <div className='titre_promotion'>
            <div className='d-flex mt-2 titre'>
              <i className='fa fa-bookmark'></i> <h1>Promotions</h1>
            </div>
            <div className='promotion_renseignement'>
              <p>Pour chaque promotion activée, bien définir les conditions.
                Plus la réduction est importante, plus vous attirerez des clients, et plus ils consommeront ! La prochaine étape sera de les fidéliser !
              </p>
            </div>
          </div>
          <div className='list_promotion'>
            <div className="accordion_bloc">
              {promo.map((item, i) => {

                if (item.id !== 6) {
                  return (
                    <div className='item' key={i}>

                      <div className='title' >
                        <div className="d-flex">
                          <Form>
                            <Form.Check
                              type="switch"

                              value={item.status}
                              checked={item.status}
                              onChange={() => handleStatus(item.id)}
                              name="status"
                            />
                          </Form>
                          <h2 onClick={() => toogle(i)}>{item.libelle}</h2>
                        </div>
                        <span>{selected === i ? <i className='fa fa-chevron-up'></i> : <i className='fa fa-chevron-down'></i>}</span>
                      </div>
                      <div className={selected === i ? 'content show' : 'content'}>
                        <h3>Conditions :</h3>
                        <h4>Hors menus, hors formules</h4>
                        <div>
                          <Form>
                            <Form.Check
                              type='checkbox'
                              id={'50Boisson' + i}
                              name="horsBoisson"
                              value={item.horsBoisson}
                              checked={item.horsBoisson}
                              onChange={() => handlehorsBoisson(item.id)}
                              label="Hors boisson."
                            />
                          </Form>
                        </div>
                        <div>
                          <Form>
                            <Form.Check
                              type='checkbox'
                              id={'50commande' + i}
                              value={item.toutCommande}
                              checked={item.toutCommande}
                              onChange={() => handleToutCommande(item.id)}
                              label=" Pour toute commande d’Entrée+Plat ou Plat+Dessert minimum par personne."
                            />
                          </Form>
                        </div>
                        <h3 className='mt-2'>Validité :</h3>
                        <h4>Valable pour le créneau horaire réservé.</h4>
                      </div>
                    </div>
                  )
                } else {




                  return (
                    <div className='item' key={i}>

                      <div className='title' >
                        <div className="d-flex flex_header_special">
                          <Form>
                            <Form.Check
                              type="switch"
                              value={item.status}
                              checked={item.status}
                              onChange={() => handleStatus(item.id)}
                              name="status"
                            />
                          </Form>
                          <h2 onClick={() => toogle(i)}>{item.name}</h2>

                          <input type="text" name='name' value={libelleSpecial} onChange={(e) => handleSpecialLibelle(e.target.value, item.id, i)} className='form-control form-control-sm w-25 ms-2 me-2' placeholder='Menu ...' />
                          {errorLibelle !== "" ?
                            <span className="errorValue">{errorLibelle}</span> : ''}

                          à

                          <input type="number" onKeyDown={blockInvalidChar} name="prix" value={prixSpecial} onChange={(e) => handleSpecialPrix(e.target.value, item.id, i)} className='form-control ms-2 me-1 w-25 form-control-sm' placeholder='Prix ...' /> Ar !
                          {errorPrix !== "" ?
                            <span className="errorValue">{errorPrix}</span> : ''}

                        </div>
                        <span>{selected === i ? <i className='fa fa-chevron-up'></i> : <i className='fa fa-chevron-down'></i>}</span>
                      </div>
                      <div className={selected === i ? 'content show' : 'content'}>
                        <div className='d-flex mt-2'>
                          <Form.Check
                            type="switch"
                            name="status"
                            checked={statusContenuMenu}
                            onChange={handleChangeStatusContenu}
                            id="custom2"
                          />
                          <h3 className='mt-1'>Ce menu comprend :</h3>
                          {errorContenuMenu !== "" ?
                            <span className="errorValue">{errorContenuMenu}</span> : ''}
                        </div>
                        <form>
                          <div className='check'>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Entrée + Plat" ? true : false} value={platMenu} onChange={() => handlePlatMenu("Entrée + Plat")} id="radio1" />
                              <label className="form-check-label" htmlFor="radio1">
                                Entrée + Plat
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Plat + Dessert" ? true : false} value={platMenu} onChange={() => handlePlatMenu("Plat + Dessert")} id="radio2" />
                              <label className="form-check-label" htmlFor="radio2">
                                Plat + Dessert
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Entrée + Plat ou Plat + Dessert" ? true : false} value={platMenu} onChange={() => handlePlatMenu("Entrée + Plat ou Plat + Dessert")} id="radio3" />
                              <label className="form-check-label" htmlFor="radio3">
                                Entrée + Plat ou Plat + Dessert
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" name="contenu" checked={platMenu === "Entrée + Plat + Dessert" ? true : false} value={platMenu} id="radio4" onChange={() => handlePlatMenu("Entrée + Plat + Dessert")} />
                              <label className="form-check-label" htmlFor="radio4">
                                Entrée + Plat + Dessert

                              </label>
                            </div>
                          </div>

                        </form>
                        <form>
                          <div className='check mt-2'>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="checkbox" value={avecContenu[0].name} name="avec contenu" checked={avecContenu[0].check} id={avecContenu[0].name} onChange={() => handleCheckAvecContenu(avecContenu[0].id)} />
                              <label className="form-check-label" htmlFor={avecContenu[0].name}> + {avecContenu[0].name}  </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="checkbox" value={avecContenu[1].name} name="avec contenu" checked={avecContenu[1].check} id={avecContenu[1].name} onChange={() => handleCheckAvecContenu(avecContenu[1].id)} />
                              <label className="form-check-label" htmlFor={avecContenu[1].name}> + {avecContenu[1].name}  </label>
                            </div>

                          </div>

                        </form>
                        <form>
                          <div className='check mt-2'>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="checkbox" name="check" onChange={handleAutrePlatMenu} checked={autrePlatMenu.check} id={autrePlatMenu.name} />
                              <input type="text" className="form-control form-control-sm" name="name" value={autrePlatMenu.name} onChange={handleAutrePlatMenu} placeholder=" ex : plat du jour + Boisson ..." />
                            </div>

                          </div>

                        </form>
                        <div className='d-flex'>
                          <Form.Check
                            type="switch"
                            checked={statuReservant}
                            onChange={() => setStatuReservant(!statuReservant)}
                            id="custom4"
                            className='mt-2'

                          />
                          <span className='remarque mt-2'>En réservant avec ce menu, vous pouvez, une fois sur place, soit bénéficier de ce menu, soit commander à la carte si vous changez d’avis </span>
                        </div>
                        <h3 className='details mt-3'>Détails</h3>
                        <div className='d-flex'>
                          <Form.Check
                            type="switch"
                            id="custom5"
                            checked={statusIntroduire}
                            onChange={() => setStatusIntroduire(!statusIntroduire)}
                            className='mt-2'

                          />
                          <input className='form-control introduire' value={introduire} onChange={(e) => handleStatusIntroduire(e)} placeholder="Pour introduire le menu. Exemple : « Au choix parmi : », « Le chef … vous propose son menu dégustation à partager à deux ou à plusieurs ..." />
                        </div>
                        {errorIntroduire !== "" ?
                          <span className="errorValue">{errorIntroduire}</span> : ''}




                        <div className='menu_carte mt-5 mb-3'>
                          <div className='row'>
                            <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                              <div className="menu_carte_item">
                                <div className='d-flex justify-content-between header_item'>
                                  <h3 className='details'>Entrée</h3>
                                  <Form.Check
                                    type="switch"
                                    id="custom5"
                                    checked={statusEntrer}
                                    onChange={() => setStatusEntrer(!statusEntrer)}
                                    className='mt-1'

                                  />
                                </div>
                                <div className='d-flex mt-3'>
                                  <input type="text" value={entrer} onChange={(e) => setEntrer(e.target.value)} className='form-control form-control-sm' placeholder='Entrée ...' />
                                  <button type="button" className='btn btn-sm' onClick={handleAddEntrer}><i className="fa fa-plus"></i></button>
                                </div>
                                {errorEntrer !== "" ?
                                  <span className="errorValue">{errorEntrer}</span> : ''}
                                {dataEntrer?.length !== 0 ?
                                  dataEntrer.map((el, index) => {
                                    return (
                                      <div className='d-flex justify-content-between mt-3 data_liste' key={index}>
                                        <h4>{el.name}</h4>
                                        <div className='menu_carte_button'>
                                          <button className="btn btn_delete btn-sm" onClick={() => handleDeleteEntrer(el.name)}><i className='fa fa-trash'></i></button>
                                        </div>
                                      </div>
                                    );
                                  }) : <p>Entreés vide ...</p>}

                              </div>
                            </div>
                            <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                              <div className="menu_carte_item">
                                <div className="d-flex justify-content-between header_item">
                                  <h3 className='details'>Plats</h3>
                                  <Form.Check
                                    type="switch"
                                    id="custom5"
                                    checked={statusPlat}
                                    onChange={() => setStatusPlat(!statusPlat)}
                                    className='mt-1'

                                  />
                                </div>
                                <div className='d-flex mt-3'>
                                  <input type="text" value={plat} onChange={(e) => setPlat(e.target.value)} className='form-control form-control-sm' placeholder='Plats ...' />
                                  <button type="button" className='btn btn-sm' onClick={handleAddPlat}><i className='fa fa-plus'></i></button>
                                </div>
                                {errorPlat !== "" ?
                                  <span className="errorValue">{errorPlat}</span> : ''}
                                {dataPlat?.length !== 0 ? dataPlat.map((el, index) => {
                                  return (
                                    <div className='d-flex justify-content-between data_liste mt-3' key={index}>
                                      <h4>{el.name}</h4>
                                      <div className='menu_carte_button'>

                                        <button className="btn btn_delete btn-sm" onClick={() => handleDeletePlat(el.name)}><i className='fa fa-trash'></i></button>
                                      </div>
                                    </div>
                                  );
                                }) : <p>Plats vide...</p>}
                              </div>
                            </div>
                            <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                              <div className="menu_carte_item">
                                <div className='d-flex justify-content-between header_item'>
                                  <h3 className='details'>Dessert</h3>
                                  <Form.Check
                                    type="switch"
                                    id="custom5"
                                    checked={statusDessert}
                                    onChange={() => setStatusDessert(!statusDessert)}
                                    className='mt-1'
                                  />
                                </div>
                                <div className='d-flex mt-3'>
                                  <input type="text" value={dessert} onChange={(e) => setDessert(e.target.value)} className='form-control form-control-sm' placeholder='Dessert ...' />
                                  <button type="button" className='btn btn-sm' onClick={handleAddDessert}><i className='fa fa-plus'></i></button>
                                </div>
                                {errorDessert !== "" ?
                                  <span className="errorValue">{errorDessert}</span> : ''}
                                {dataDessert?.length !== 0 ? dataDessert.map((el, index) => {
                                  return (
                                    <div className='d-flex justify-content-between data_liste mt-3' key={index}>
                                      <h4>{el.name}</h4>
                                      <div className='menu_carte_button'>

                                        <button className="btn btn_delete btn-sm" onClick={() => handleDeleteDessert(el.name)}><i className='fa fa-trash'></i></button>
                                      </div>
                                    </div>
                                  );
                                }) : <p>Dessert vide...</p>}

                              </div>
                            </div>
                            <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                              <div className="menu_carte_item">

                                <div className='d-flex autre_item_flex'>
                                  <Form.Check
                                    type="switch"
                                    id="custom5"
                                    checked={statusAutre}
                                    onChange={() => setStatusAutre(!statusAutre)}
                                    className='mt-1'

                                  />
                                  <input type="text" value={nomAutre} onChange={(e) => setNomAutre(e.target.value)} className='form-control form-control-sm' placeholder='Nom ...' />
                                </div>
                                <div className='d-flex mt-3'>
                                  <input type="text" value={autre} onChange={(e) => setAutre(e.target.value)} className='form-control form-control-sm' placeholder='Item ...' />
                                  <button type="submit" className='btn btn-sm' onClick={handleAddAutre}><i className='fa fa-plus'></i></button>
                                </div>
                                {errorAutre !== "" ?
                                  <span className="errorValue">{errorAutre}</span> : ''}
                                {dataAutre?.length !== 0 ? dataAutre.map((el, index) => {
                                  return (
                                    <div className='d-flex justify-content-between data_liste  mt-3' key={index}>
                                      <h4>{el.name}</h4>
                                      <div className='menu_carte_button'>
                                        <button className="btn btn_delete btn-sm" onClick={() => handleDeleteAutre(el.name)}><i className='fa fa-trash'></i></button>
                                      </div>
                                    </div>
                                  );
                                }) : <p>Données vide...</p>}

                              </div>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>
                  )
                }

              })}
            </div>

            <div className='d-flex mt-3'>
              <Form>
                <Form.Check
                  type="switch"
                  id="autre"
                  defaultChecked="true"
                />
              </Form>
              <h3 className='reservation_simple'>Réservation sans offre : <span>Réservation simple</span></h3>
            </div>
            {loadData === true ?
              <div className="d-flex justify-content-center">
                <Spinner animation="border" className="load" variant="info" size="md" />
              </div> : ''}
            <div className='action'>
              <div className='d-flex justify-content-center'>
                <div className='liste_action'>
                  <button className='btn' onClick={() => handleShow(true)}>Visualiser</button>
                  <button className='btn' onClick={handleCancel}>Annuler</button>
                  {loading ? <Button className='btn btn_ajoutePromotion' disabled>
                    <Spinner

                      animation="border"
                      size="sm"
                      variant="info"
                    />
                    Loading...
                  </Button> : <button className='btn' onClick={handlePubier}>Publier</button>}

                </div>
              </div>
            </div>
            <p className='version'>Version 1</p>
          </div>

        </div>





        {/* 
        MODAL COMPONENT  */}

        <Modal show={showModal} fullscreen={fullscreen} onHide={handleClose}>
          <Modal.Body>
            <div className='modal_visualiser'>
              <div className='modal_visualiser_header'>
                <h5>L'aperçue de votre donner dans la page restaurants</h5>
                <span className='close' onClick={handleClose}><i className='fa fa-close'></i></span>
              </div>
              <div className='restoPagePromotion'>
                <div className='restoPage_content'>
                  <div className='resto_option'>
                    <div className='row'>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8'>
                        <div className='resto_apropos'>
                          <div className='resto_apropos_content'>
                            <h1 className='text-center'>{restaurant.nomRestaurant}</h1>
                            <div className='cuisine_prix'>
                              <div className="row">

                                {cuisine.length !== 0 ?
                                  cuisine.map((item, index) => {
                                    return (
                                      <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-3' key={index}>
                                        <span ><i className='fa fa-cutlery'></i>{item.libelle}</span>
                                      </div>
                                    )
                                  })
                                  : ''}

                              </div>
                              <div className='row'>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <span><i className='fa fa-map-marker'></i>{restaurant.adresse}</span>
                                </div>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <span><i className='fa fa-bookmark'></i>Prix Moyenne de {prixMoyenne.length !== 0 ? prixMoyenne[0]?.prix : "000"}Ar</span>
                                </div>

                              </div>
                            </div>
                            <div className='favoris_gif'>
                              <i className='fa fa-heart'></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
                        <div className='resto_favoris'>
                          <div className='resto_favoris_content'>
                            <div className="d-flex justify-content-center">
                              <div className='resto_note_avis'>
                                <div>
                                  <div className='resto_note'>Note/<span>{restaurant.notes && restaurant.notes.length === 0 ? 0 : restaurant.notes[0].note}</span></div>
                                  <div className='resto_avis'>Avis/<span>{restaurant.avis && restaurant.avis.length === 0 ? 0 : restaurant.avis.length}</span></div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex justify-content-center">
                              {exitePromo.length === 0 ? <div className='resto_promotion mb-4'>
                                {viewPromotion()}
                              </div> :
                                <div className='resto_promotion'>
                                  {viewPromotion()}
                                  {restaurant.creneauPromos.length !== 0 ?
                                    viewCreneau(restaurant.creneauPromos[0])
                                    : ''}
                                </div>}
                            </div>
                          </div>
                          <div className='resto_footer_reserver'>
                            <div className='d-flex justify-content-center'>
                              <button className="btn">Réserver</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <PhotoProvider>
                    <div className='resto_photos'>
                      {selectImage.length !== 0 ?
                        <Slider {...settings}>
                          {selectImage.map((item, index) => {
                            return (<div className='image' key={index}>
                              <PhotoView src={BASE_URL + item.urlPhoto}>
                                <img src={BASE_URL + item.urlPhoto} alt="logo restaurant" />
                              </PhotoView>
                            </div>)
                          })}
                        </Slider>
                        : <p>Photos non disponible ...</p>}

                    </div>
                  </PhotoProvider>
                  <div className='resto_description'>
                    <h2> <i className='fa fa-tag'></i>Description du restaurant</h2>
                    <div className='resto_description_content'>
                      <div className='chef'>
                        <img src={Chef} alt="chef avatar" />
                      </div>
                      <p>{description === null ? 'Description non disponible ...' : description.split('\n').map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}</p>
                    </div>

                  </div>



                  <div className='row'>


                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8'>
                      <Tabs
                        defaultActiveKey="carte"
                        id="fill-tab-example"
                        className="mb-3"
                        justify
                      >
                        <Tab eventKey="carte" title="Cartes">
                          {entrerResto.length === 0 && platResto.length === 0 && dessertResto.length === 0 && boisson.length === 0 ?
                            <h4> <i className='fa fa-cutlery pas'></i>Pas de contenue dans la carte</h4>
                            :
                            <h4> <i className='fa fa-cutlery'></i>A la carte</h4>
                          }

                          <div className='resto_carte'>
                            <div className='row'>
                              {entrerResto.length !== 0 ?
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center'>Entrées</h5>
                                    {entrerResto.map((item, index) => {
                                      if (index === entrerResto.length - 1) {
                                        return (<div className='resto_entrer' key={index}>
                                          <div className='img'>
                                            <img src={EntrerIcon} alt="avatar carte" />
                                          </div>
                                          <div className='resto_carte_content'>
                                            <h6>{item.libelle}</h6>
                                            <span>{item.prix} Ar</span>
                                          </div>
                                        </div>)
                                      } else {
                                        return (<>
                                          <div className='resto_entrer' key={index}>
                                            <div className='img'>
                                              <img src={EntrerIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                          <hr />
                                        </>)
                                      }

                                    })}


                                  </div>
                                </div>
                                : ''}

                              {platResto.length !== 0 ?
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center'>Plats</h5>
                                    {platResto.map((item, index) => {
                                      if (index === platResto.length - 1) {
                                        return (<div className='resto_plat' key={index}>
                                          <div className='img'>
                                            <img src={PlatIcon} alt="avatar carte" />
                                          </div>
                                          <div className='resto_carte_content'>
                                            <h6>{item.libelle}</h6>
                                            <span>{item.prix} Ar</span>
                                          </div>
                                        </div>)
                                      } else {
                                        return (<>
                                          <div className='resto_plat' key={index}>
                                            <div className='img'>
                                              <img src={PlatIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                          <hr />
                                        </>
                                        )
                                      }

                                    })}

                                  </div>
                                </div>
                                : ''}


                              {dessertResto.length !== 0 ?
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center'>Desserts</h5>

                                    {dessertResto.map((item, index) => {
                                      if (index === dessertResto.length - 1) {
                                        return (
                                          <div className='resto_dessert' key={index}>
                                            <div className='img'>
                                              <img src={DessertIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <>
                                            <div className='resto_dessert' key={index}>
                                              <div className='img'>
                                                <img src={DessertIcon} alt="avatar carte" />
                                              </div>
                                              <div className='resto_carte_content'>
                                                <h6>{item.libelle}</h6>
                                                <span>{item.prix} Ar</span>
                                              </div>
                                            </div>
                                            <hr />
                                          </>
                                        )
                                      }
                                    })}


                                  </div>

                                </div>
                                : ''}


                              {boisson.length !== 0 ?

                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                                  <div className='resto_carte_bloc'>
                                    <h5 className='text-center boisson'>Boissons</h5>
                                    {boisson.map((item, index) => {
                                      if (index === boisson.length - 1) {
                                        return (
                                          <div className='resto_boisson' key={index}>
                                            <div className='img'>
                                              <img src={BoissonIcon} alt="avatar carte" />
                                            </div>
                                            <div className='resto_carte_content'>
                                              <h6>{item.libelle}</h6>
                                              <span>{item.prix} Ar</span>
                                            </div>
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <>
                                            <div className='resto_boisson' key={index}>
                                              <div className='img'>
                                                <img src={BoissonIcon} alt="avatar carte" />
                                              </div>
                                              <div className='resto_carte_content'>
                                                <h6>{item.libelle}</h6>
                                                <span>{item.prix} Ar</span>
                                              </div>
                                            </div>
                                            <hr />
                                          </>
                                        )
                                      }
                                    })}



                                  </div>

                                </div>
                                : ''}

                            </div>
                          </div>
                        </Tab>



                        <Tab eventKey="menu" title="Menus">
                          {menuResto.length === 0 ? <h4> <i className='fa fa-cutlery pas'></i>Pas de contenu dans le Menus</h4> : <h4> <i className='fa fa-cutlery'></i>Menus</h4>}

                          <div className="row p-2">

                            {menuResto.map((item, index) => {
                              return (
                                <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4' key={index}>
                                  <div className='resto_menus'>
                                    <div className='resto_menu_header'>
                                      <div className='img'>
                                        <img src={Menus} alt="avatar menus" />
                                      </div>
                                      <div className='resto_menu_titre'>
                                        <h5>{item.nomMenu} à <span>{item.prixMenu} Ar</span></h5>
                                      </div>
                                    </div>
                                    <div className='resto_menu_content'>
                                      <p>{item.introduire.slice(0, 80)}...</p>
                                      <div className='d-flex justify-content-center'>
                                        <button className='btn' onClick={() => handleShowDetailMenu(item)}>Voir le détail de ce menu</button>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              );
                            })}

                          </div>


                        </Tab>



                        <Tab eventKey="avecOffre" title="Avec Offres">
                          <div className='resto_promo_map'>
                            <div className='row'>
                              <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                <div className='resto_promo_titre'>
                                  <h4> <i className='fa fa-bullhorn'></i>Avec Offre</h4>
                                </div>
                                <div className='resto_promo_content'>

                                  {
                                    promo.map((elPromo, iPromo) => {
                                      if (elPromo.status === true && elPromo.name === "Promotion de -50%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -50% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.status === true && elPromo.name === "Promotion de -40%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -40% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.status === true && elPromo.name === "Promotion de -30%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -30% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.status === true && elPromo.name === "Promotion de -20%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -20% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.status === true && elPromo.name === "Promotion de -10%") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : -10% sur la carte</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                        </div>);
                                      } else if (elPromo.status === true && elPromo.name === "Promotion : Menu spécial") {
                                        return (<div className='resto_promo_content_item' key={iPromo}>
                                          <div className='item_liste'>
                                            <h5>Promo : {libelleSpecial !== "" ? libelleSpecial : "Promotion special"} à {prixSpecial !== "" ? prixSpecial : "000"} Ar</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                          <div className='item_action_creneau creneau_special'>
                                            {libelleSpecial !== "" ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                          </div>
                                          <div className='item_action_content'>
                                            <div className='item_action_creneau_responsive'>
                                              {libelleSpecial !== "" ? <span className="item_detail_menu" onClick={handleShowDetailSPecial}>Voir le détail de ce menu</span> : ''}
                                            </div>
                                          </div>
                                        </div>)
                                      }
                                    })
                                  }



                                </div>
                                <div className='resto_promo_titre mt-3'>
                                  <h4> <i className='fa fa-bullhorn'></i>Sans Offre</h4>
                                </div>
                                <div className='resto_promo_content'>
                                  <div className='resto_promo_content_item'>
                                    <div className='item_liste'>
                                      <h5>Réservations simple</h5>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </Tab>




                        <Tab eventKey="avis" title={"Nombre d'avis" + restaurant?.avis.length}>
                          <div className='resto_avis'>
                            <div className='resto_avis_header'>
                              <h4><i className='fa fa-tag'></i> Nombre d'avis {restaurant?.avis.length}</h4>
                            </div>
                            <div className='resto_avis_content'>


                              {restaurant?.avis.map((el, index) => {
                                return (
                                  viewAvisListe(el, index)
                                )
                              })}

                              {/* <div className='d-flex justify-content-center'>
                                <div className='pagination_avis'>
                                  <Pagination count={10} />
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </Tab>
                      </Tabs>

                    </div>


                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4'>
                      <div className='payement_plus'>
                        <div className='payement_plusContent'>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className='plus_restaurant'>
                              <div className='d-flex justify-content-center'>
                                <div className='titre_plus'>
                                  <span><i className='fa fa-bolt'></i> Les + du restaurant</span>
                                </div>
                              </div>
                              <div className='plus_content'>
                                <div className='row'>
                                  {service?.length !== 0 ?
                                    service?.map((item, index) => {
                                      return (
                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                          <div className='item_plus'>
                                            <div className='image_plus'>
                                              <img src={Plus} alt="avatar plus restaurant" />
                                            </div>
                                            <div className='value_plus'>
                                              <span>{item.libelle}</span>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                    : ''}
                                  {regime?.length !== 0 ?
                                    regime?.map((item, index) => {
                                      return (
                                        <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                          <div className='item_plus'>
                                            <div className='image_plus'>
                                              <img src={Plus} alt="avatar plus restaurant" />
                                            </div>
                                            <div className='value_plus'>
                                              <span>{item.libelle}</span>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })
                                    : ''}


                                </div>
                              </div>

                            </div>
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className='payement_restaurant'>
                              <div className='payement_restaurantContent'>
                                <div className='titre_payement'>
                                  <span><i className='fa fa-money'></i> Mode de payement acceptés</span>
                                </div>
                              </div>
                              <div className='payement_content'>
                                <div className='row'>
                                  {payement?.length !== 0 ?
                                    payement?.map((item, index) => {
                                      return (<div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                        <div className='item_payement'>
                                          <div className='image_payement'>
                                            <img src={Money} alt="avatar plus restaurant" />
                                          </div>
                                          <div className='value_payement'>
                                            <span>{item.libelle}</span>
                                          </div>
                                        </div>
                                      </div>)
                                    })

                                    : ''}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='resto_map'>
                              <div className='resto_map_titre'>
                                <h4> <i className='fa fa-map-marker'></i>Localisation – Plan / adresse</h4>
                              </div>

                              <div className="resto_map_content">
                                <h5>Adresse</h5>
                                <p>{restaurant.adresse} : {restaurant.precision}</p>

                                <PhotoProvider>
                                  {planUrl !== null ?
                                    <div className='resto_map_image'>
                                      <PhotoView src={BASE_URL + planUrl}>
                                        <img src={BASE_URL + planUrl} alt="Map" />
                                      </PhotoView>
                                    </div>
                                    : ''}
                                </PhotoProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <PhotoProvider>
                    {restaurant?.photoRestos.length !== 0 ?
                      <div className="resto_photo_telecharger">
                        <div className='resto_photo_telecharger_titre'>
                          <h4> <i className='fa fa-photo'></i>Photo des clients</h4>
                        </div>
                        <div className='row'>
                          {restaurant?.photoRestos.map((element, index) => {
                            return (
                              <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3' key={index}>
                                <div className='resto_photo_img'>
                                  <PhotoView src={BASE_URL + element.photoUrl}>
                                    <img src={BASE_URL + element.photoUrl} alt="telecharger client" />
                                  </PhotoView>
                                </div>
                              </div>)
                          })}


                        </div>
                      </div>
                      : ""}
                  </PhotoProvider>






                </div>
                <Modal
                  show={show}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered

                  onHide={handleCloseDetailMenu}
                >
                  <Modal.Body className="shadow">
                    <div className='modal_detail_menu'>
                      <div className='header_detail_menu'>
                        <h5>{elementMenu.nomMenu} à <span>{elementMenu.prixMenu} Ar</span></h5>
                        <span className='close' onClick={handleCloseDetailMenu}><i className='fa fa-close'></i></span>
                      </div>
                      <div className='content_detail_menu'>
                        <div className='content_detail_description'>
                          <h6>Ce menu comprend:</h6>
                          <div className='content_detail_liste mt-2'>
                            {elementMenu.platMenu !== "" && elementMenu.avecContenus?.length !== 0 ?
                              <><span className='detail_liste'>{elementMenu.platMenu}</span>
                                <span className='detail_plus'>+</span></> :
                              elementMenu.platMenu !== "" && elementMenu.avecContenus?.length === 0 ?
                                <span className='detail_liste'>{elementMenu.platMenu}</span>
                                : ""
                            }

                            {elementMenu.autrePlatMenu !== "" && elementMenu.avecContenus?.length !== 0 ?
                              <><span className='detail_liste'>{elementMenu.autrePlatMenu}</span> <span className='detail_plus'>+</span></> :
                              elementMenu.autrePlatMenu !== "" && elementMenu.avecContenus?.length === 0 ?
                                <span className='detail_liste'>{elementMenu.autrePlatMenu}</span> : ''}


                            {elementMenu.avecContenus?.length !== 0 ?
                              elementMenu.avecContenus?.map((elAvec, iAvec) => {
                                if (iAvec === elementMenu.avecContenus?.length - 1) {
                                  return (<span className='detail_liste' key={iAvec}>{elAvec.libelle}</span>);
                                } else {

                                  return (<div key={iAvec} ><span className='detail_liste'>{elAvec.libelle}</span><span className='detail_plus'>+</span></div>);
                                }

                              })
                              : ''}
                          </div>
                          <h6>Ce menu disponible:</h6>
                          <div className='content_detail_liste mt-2'>

                            {elementMenu.moments?.length !== 0 ?
                              elementMenu.moments?.map((elMoment, iMoment) => {
                                return (
                                  <span className='detail_liste_disponible' key={iMoment}>{elMoment.libelle}</span>
                                );
                              }) : ""}



                          </div>
                          <div className='content_detail_liste mt-3'>
                            <span className='me-2' >Le</span>
                            {elementMenu.jours?.length !== 0 ?
                              elementMenu.jours?.map((elJour, iJour) => {
                                return (<span className='detail_liste_disponible' key={iJour}>{elJour.libelle}</span>);
                              })
                              : ''}
                          </div>
                        </div>
                        <div className='row'>
                          {elementMenu.entrerMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Entrée</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.entrerMenus?.map((elEntrer, iEntrer) => {
                                    if (iEntrer === elementMenu.entrerMenus?.length - 1) {
                                      return (<span key={iEntrer}>{elEntrer.libelle}</span>);
                                    } else {

                                      return (<><span key={iEntrer}>{elEntrer.libelle}</span>
                                        <hr /></>);
                                    }

                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {elementMenu.platMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Plats</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.platMenus?.map((elPlat, iPlat) => {
                                    if (iPlat === elementMenu.platMenus?.length - 1) {
                                      return (<span key={iPlat}>{elPlat.libelle}</span>);
                                    } else {

                                      return (<><span key={iPlat}>{elPlat.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {elementMenu.dessertMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Dessert</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.dessertMenus?.map((elDessert, iDessert) => {
                                    if (iDessert === elementMenu.dessertMenus?.length - 1) {
                                      return (<span key={iDessert}>{elDessert.libelle}</span>);
                                    } else {
                                      return (<><span key={iDessert}>{elDessert.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}
                          {elementMenu.autreMenus?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>{elementMenu.nomAutre}</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {elementMenu.autreMenus?.map((elAutre, iAutre) => {
                                    if (iAutre === elementMenu.autreMenus?.length - 1) {
                                      return (<span key={iAutre}>{elAutre.libelle}</span>);
                                    } else {
                                      return (<><span key={iAutre}>{elAutre.libelle}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}

                        </div>
                        <p className='mt-3'>
                          {elementMenu.introduire}
                        </p>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>


                <Modal
                  show={showSpecial}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered

                  onHide={handleCloseDetailSpecial}
                >
                  <Modal.Body className="shadow">
                    <div className='modal_detail_menu'>
                      <div className='header_detail_menu'>
                        <h5>{libelleSpecial} à <span>{prixSpecial} Ar</span></h5>
                        <span className='close' onClick={handleCloseDetailSpecial}><i className='fa fa-close'></i></span>
                      </div>
                      <div className='content_detail_menu'>
                        <div className='content_detail_description'>
                          <h6>Ce menu comprend:</h6>
                          <div className='content_detail_liste mt-2'>
                            {platMenu !== "" && avecContenuTrue.length !== 0 && autrePlatMenu.name === "" ?
                              <><span className='detail_liste'>{platMenu}</span>
                                <span className='detail_plus'>+</span></> :
                              platMenu !== "" && avecContenuTrue.length === 0 && autrePlatMenu.name === "" ?
                                <span className='detail_liste'>{platMenu}</span>
                                : ''
                            }

                            {autrePlatMenu.name !== "" && avecContenuTrue.length !== 0 ?
                              <><span className='detail_liste'>{autrePlatMenu.name}</span> <span className='detail_plus'>+</span></> :
                              autrePlatMenu.name !== "" && avecContenuTrue.length === 0 ?
                                <span className='detail_liste'>{autrePlatMenu.name}</span> : ''}


                            {avecContenuTrue.length !== 0 ?

                              avecContenuTrue?.map((elAvec, iAvec) => {

                                if (iAvec === avecContenuTrue?.length - 1) {
                                  return (<span className='detail_liste' key={iAvec}>{elAvec.name}</span>);
                                } else {

                                  return (<div key={iAvec} ><span className='detail_liste'>{elAvec.name}</span><span className='detail_plus'>+</span></div>);
                                }

                              })
                              : ''}
                          </div>

                        </div>
                        <div className='row'>
                          {dataEntrer.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Entrée</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {dataEntrer.map((elEntrer, iEntrer) => {
                                    if (iEntrer === dataEntrer.length - 1) {
                                      return (<span key={iEntrer}>{elEntrer.name}</span>);
                                    } else {

                                      return (<><span key={iEntrer}>{elEntrer.name}</span>
                                        <hr /></>);
                                    }

                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {dataPlat?.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Plats</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {dataPlat?.map((elPlat, iPlat) => {
                                    if (iPlat === dataPlat.length - 1) {
                                      return (<span key={iPlat}>{elPlat.name}</span>);
                                    } else {

                                      return (<><span key={iPlat}>{elPlat.name}</span>
                                        <hr /></>)
                                    }
                                  })}


                                </div>
                              </div>
                            </div>
                            : ''}


                          {dataDessert.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>Dessert</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {dataDessert?.map((elDessert, iDessert) => {
                                    if (iDessert === dataDessert.length - 1) {
                                      return (<span key={iDessert}>{elDessert.name}</span>);
                                    } else {
                                      return (<><span key={iDessert}>{elDessert.name}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}
                          {dataAutre.length !== 0 ?
                            <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                              <div className='content_detail_item'>
                                <div className='content_detail_itemTitre'>
                                  <h6 className='text-center'>{nomAutre}</h6>

                                </div>
                                <div className='content_detail_itemListe'>
                                  {dataAutre?.map((elAutre, iAutre) => {
                                    if (iAutre === dataAutre.length - 1) {
                                      return (<span key={iAutre}>{elAutre.name}</span>);
                                    } else {
                                      return (<><span key={iAutre}>{elAutre.name}</span>
                                        <hr /></>)
                                    }
                                  })}

                                </div>
                              </div>
                            </div>
                            : ''}

                        </div>
                        <p className='mt-3'>
                          {introduire}
                        </p>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>



              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>

    </div>
  )
}

export default Promotion